import { render, staticRenderFns } from "./advice_stars.vue?vue&type=template&id=7161802d"
import script from "./advice_stars.js?vue&type=script&lang=js&external"
export * from "./advice_stars.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports